import { Component } from '@angular/core';

@Component({
  selector: 'icon-facebook',
  templateUrl: './icon-facebook.component.html',
  styles: []
})
export class IconFacebookComponent {}
